import { jobOpeningPages, jobOpeningDetailsTabs } from '../../../../utils/types/JobOpenings';
import { ALWAYS_ENABLED_PAGES, COMPLETE_MAPPINGS, PAGE_ELEMENT_MAP } from '../constants';
import { PageStatus } from '../interfaces';

export const getPageStatus = (
  currentPage: jobOpeningPages,
  jobOpeningElements: string[],
  completedTabs: jobOpeningDetailsTabs[],
  isLoading: boolean,
): { status: PageStatus; requiredTabs: string[] } => {
  if (isLoading) {
    return { status: 'loading', requiredTabs: [] };
  }

  if (ALWAYS_ENABLED_PAGES.includes(currentPage)) {
    return { status: 'enabled', requiredTabs: [] };
  }

  const requiredElement = PAGE_ELEMENT_MAP[currentPage];
  if (!jobOpeningElements.includes(requiredElement)) {
    return { status: 'disabled', requiredTabs: [] };
  }

  const requiredTabsForPage = COMPLETE_MAPPINGS[currentPage] || [];
  const incomplete = requiredTabsForPage.filter((tab) => !completedTabs.includes(tab));

  return {
    status: incomplete.length === 0 ? 'enabled' : 'requiredCompletion',
    requiredTabs: incomplete,
  };
};
